<template>
  <div
    :class="{ 'd-none': boardDensity === 'LIST' && $vuetify.breakpoint.xs }"
    class="board__list-estates"
    v-if="realties"
  >
    <v-chip
      v-for="realty in realties"
      :key="realty.code"
      class="mt-1 mr-1"
      x-small
    >
      <span class="grey--text text--darken-2">
        {{ realty.code }}
      </span>
    </v-chip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BoardItemRealties',

  props: {
    realties: {
      default: null,
    },
  },

  computed: {
    ...mapGetters(['boardDensity']),
  },
}
</script>
